(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function setupCollectionFilters() {
    document.querySelectorAll('[data-collection-filters]:not([data-ready])').forEach((panel) => {
      panel.dataset.ready = 'true';
      panel.open = window.matchMedia('(min-width: 991px)').matches;
    });
  }
  setupCollectionFilters();
  document.addEventListener('shopify:section:load', setupCollectionFilters);

  } catch(e) { console.error(e); }
})();
})();
